import './LinkLibrarySubHeading.scss';

import React, { FunctionComponent } from 'react';

import { Tooltip } from '../ToolTip/Tooltip';
import { useTranslation } from 'react-i18next';

export const LinkLibrarySubHeading: FunctionComponent = () => {
  const { t } = useTranslation();
  return (
    <div className="subheading__wrapper">
      <h2 className="subheading__heading">{t('linkLibrary.subheading')}</h2>
      <Tooltip
        buttonText={t('linkLibrary.infoLabel')}
        dataQa="subheading-tooltip"
        className="subheading__toolTip"
      >
        {t('linkLibrary.totals.tooltip.content')}{' '}
        <a
          href="https://justgiving-charitysupport.zendesk.com/hc/en-us/articles/6234583694493-How-to-use-your-Giving-Checkout-link-library"
          target="_blank"
          rel="noreferrer"
        >
          {t('linkLibrary.helpLink')}
        </a>
        {'.'}
      </Tooltip>
    </div>
  );
};
